import palettes from './note-palettes/palettes.json'
import { type NoteColor } from './types'

export type NotePaletteId = 'dynamic' | 'monokai' | 'nord' | 'dracula' | 'primary'
  | 'dawnbringer8' | 'sobeachy8' | 'clement8' | 'matriax8c' | 'pollen8' | 'funkyfuture8'
export interface NotePalette {
  id: NotePaletteId
  name: string
  author?: string
  colors: Record<NoteColor, { light: string; dark: string }>
}

// Also packaged as an Android Java resource. Palette changes never rewrite notes.
export const NOTE_PALETTES = palettes as NotePalette[]
export function notePalette(id: unknown): NotePalette {
  return NOTE_PALETTES.find((palette) => palette.id === id) ?? NOTE_PALETTES[0]
}

/** Full-strength backgrounds need their own foreground, not the app theme's. */
export function noteForeground(background: string): '#000000' | '#ffffff' {
  const channels = [1, 3, 5].map((i) => parseInt(background.slice(i, i + 2), 16) / 255)
    .map((v) => v <= .04045 ? v / 12.92 : ((v + .055) / 1.055) ** 2.4)
  const luminance = channels[0] * .2126 + channels[1] * .7152 + channels[2] * .0722
  return (luminance + .05) / .05 >= 1.05 / (luminance + .05) ? '#000000' : '#ffffff'
}
